import { jsx as _jsx } from "react/jsx-runtime";
import { TextField, ThemeProvider, inputBaseClasses } from '@mui/material';
import { useState } from 'react';
import { verySmallInputTheme } from '../../../../cosmetics/Themes/MuiInputSmaller';
export const useAdjacentNodeFilter = ({ keyPrefix }) => {
    const [filterString, setFilterString] = useState('');
    const adjacentNodeFilter = (n) => {
        const name = n.name;
        return name ? name.toLowerCase().includes(filterString.toLowerCase()) : true;
    };
    return {
        filterComponent: (_jsx(ThemeProvider, { theme: verySmallInputTheme, children: _jsx(TextField, { value: filterString,
                onChange: (e) => {
                    setFilterString(e.target.value);
                },
                size: 'small',
                placeholder: 'Type to filter...',
                sx: {
                    fontSize: 10,
                    [`& .${inputBaseClasses.input}`]: {
                        paddingBlock: '4px',
                        paddingInline: 1,
                    },
                } }, `${keyPrefix ?? ''}_nameFilter`) })),
        filterString,
        adjacentNodeFilter,
    };
};
